import i18n from 'i18next';
import { initReactI18next, Translation } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslation from '../locales/en/en.json';

import arTranslation from '../locales/ar/ar.json';
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      ar: { translation : arTranslation}
    },
    fallbackLng: 'en', // Default language
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
